import React from 'react';
import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

const SyncPmsCell = ({
  planPackageId,
  rowIndex,
  hidden,
  disabled,
  onOpenSyncModal,
}) => {
  if (!planPackageId) return '';
  if (hidden) return '';

  return (
    <Button
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onOpenSyncModal(planPackageId);
      }}
      color="secondary"
      size="small"
      className="mr-10"
      data-testid={`sync-plan-pms-location-${rowIndex}`}
    >
      Sync to PMS
    </Button>
  );
};

SyncPmsCell.propTypes = {
  planPackageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rowIndex: PropTypes.number.isRequired,
  hidden: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onOpenSyncModal: PropTypes.func.isRequired,
};

SyncPmsCell.defaultProps = {
  planPackageId: null,
};

/**
 * Wrapper that receives a render prop and calls it (does not use it as an element).
 * Satisfies the rule: render props must be called by the receiving component.
 */
export const SyncPmsCellWrapper = ({
  renderSyncPmsCell,
  planPackageId,
  rowIndex,
}) => renderSyncPmsCell(planPackageId, rowIndex);

SyncPmsCellWrapper.propTypes = {
  renderSyncPmsCell: PropTypes.func.isRequired,
  planPackageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rowIndex: PropTypes.number.isRequired,
};

export default SyncPmsCell;
